// extracted by mini-css-extract-plugin
export default {"root":"style-module__root___czgSn"};